// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2oQwx","content":"styles_content__141ci","intro":"styles_intro__39keZ"};